import React from 'react';
import { useNavigate } from 'react-router-dom';

const IndexModal = ({ isOpen, onClose, surahs }) => {
  const navigate = useNavigate();

  const handleSurahClick = (surahNumber) => {
    navigate(`/surah/${surahNumber}`);
    onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[60] flex items-start justify-center"
      style={{
        background: 'rgba(0, 0, 0, 0.7)',
        paddingTop: 'calc(80px + var(--safe-area-top))',
        paddingBottom: 'var(--safe-area-bottom)',
      }}
      onClick={onClose}
      onKeyDown={handleKeyDown}
    >
      {/* Modal Content */}
      <div 
        className="w-full max-w-4xl mx-4 rounded-xl shadow-2xl overflow-hidden"
        style={{
          background: 'var(--bg-elevated)',
          border: '2px solid var(--border-default)',
          maxHeight: 'calc(var(--app-height) - 100px - var(--safe-area-top) - var(--safe-area-bottom))',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div 
          className="p-4 border-b sticky top-0 z-10"
          style={{
            background: 'var(--bg-elevated)',
            borderColor: 'var(--border-default)',
          }}
        >
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold text-arabic" style={{ color: 'var(--text-arabic)' }}>
                فهرس القرآن
              </h2>
              <p className="text-base font-semibold mt-1" style={{ color: 'var(--text-english)' }}>
                Quran Index - Revelation Order
              </p>
            </div>
            
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-lg font-medium text-sm transition-all"
              style={{
                background: 'var(--button-default)',
                border: '2px solid var(--border-strong)',
                color: 'var(--text-english)',
              }}
            >
              Close
            </button>
          </div>
          
          <p className="text-xs mt-3" style={{ color: 'var(--text-secondary)', opacity: 0.7 }}>
            All 114 Surahs ordered by revelation • Press ESC to close
          </p>
        </div>

        {/* Surah List */}
        <div 
          className="overflow-y-auto p-4"
          style={{
            maxHeight: 'calc(var(--app-height) - 200px - var(--safe-area-top) - var(--safe-area-bottom))',
          }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {surahs.map((surah) => (
              <button
                key={surah.number}
                onClick={() => handleSurahClick(surah.number)}
                className="p-4 rounded-lg text-left transition-all"
                style={{
                  background: 'var(--bg-primary)',
                  border: '2px solid var(--border-default)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'var(--gold-muted)';
                  e.currentTarget.style.borderColor = 'var(--gold-primary)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'var(--bg-primary)';
                  e.currentTarget.style.borderColor = 'var(--border-default)';
                }}
              >
                <div className="flex items-center gap-4">
                  {/* Revelation Number */}
                  <div className="flex flex-col items-center gap-1">
                    <div 
                      className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm"
                      style={{
                        background: 'var(--gold-muted)',
                        border: '2px solid var(--gold-primary)',
                        color: 'var(--gold-hover)',
                      }}
                    >
                      {surah.revelationOrder}
                    </div>
                    <span className="text-xs" style={{ color: 'var(--text-secondary)', opacity: 0.6 }}>
                      #{surah.number}
                    </span>
                  </div>
                  
                  {/* Surah Info */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-baseline gap-2 mb-1">
                      <span 
                        className="text-lg font-bold text-arabic"
                        style={{ color: 'var(--text-arabic)' }}
                      >
                        {surah.name}
                      </span>
                      <span 
                        className="text-sm font-semibold truncate"
                        style={{ color: 'var(--text-english)' }}
                      >
                        {surah.englishName}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 text-xs flex-wrap" style={{ color: 'var(--text-secondary)' }}>
                      <span className="truncate">{surah.englishNameTranslation}</span>
                      <span>•</span>
                      <span 
                        className="px-2 py-0.5 rounded"
                        style={{
                          background: surah.revelationType === 'Meccan' 
                            ? 'rgba(59, 130, 246, 0.15)' 
                            : 'rgba(16, 185, 129, 0.15)',
                          color: surah.revelationType === 'Meccan' 
                            ? 'rgb(59, 130, 246)' 
                            : 'rgb(16, 185, 129)',
                        }}
                      >
                        {surah.revelationType}
                      </span>
                      <span>•</span>
                      <span>{surah.numberOfAyahs} Ayahs</span>
                    </div>
                  </div>
                  
                  {/* Arrow */}
                  <div style={{ color: 'var(--gold-primary)' }}>→</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndexModal;

